import React, { useContext, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { AppBar, Badge, Box, IconButton, Toolbar, Divider, InputBase, Typography } from "@mui/material";
import { ReactComponent as Nine_dots } from "assets/icons/9_dots/Nine_dots.svg";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import QuickCreate from "components/Icons/QuickCreate";
import NotificationIcon from "components/Icons/NotificationIcon";
import Button from "components/ui/Button";
import Tooltip from "components/ui/Tooltip";
import { ReactComponent as ExitIconRaw } from "assets/icons/Clients_Flow_Icons/exitIcon.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useClientContext } from "context/ClientContext";
import { useGlobalContext } from "context/GlobalContext";
import CartIcon from "../Icons/CartIcon";
import SortContext from "context/SortContext";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "store/cartSlice";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": { backgroundColor: "#f0f0f0" },
  // width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const StyledButton = styled(Button)(({ theme, bgcolor }) => ({
  width: "9vw",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "0.92vw",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: bgcolor ? bgcolor : "#ffffff",
  border: `1px solid ${bgcolor ? bgcolor : "#ffffff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  padding: "10px",
  "&:hover": {
    backgroundColor: bgcolor,
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

const ExitIcon = styled(ExitIconRaw)(() => ({
  width: "18px",
  height: "18px",
  flexShrink: 0,
  display: "inline-block",
  "& path, & circle, & rect": {
    fill: "currentColor",
  },
}));

const ExitButton = styled(Button)(() => ({
  // width: "70px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "20px",
  height: "36px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "uppercase",
  padding: "10px 18px !important",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "#000",
  },
}));

const ClientsFlowHeader = () => {
  const location = useLocation();
  let state = location?.state;
  let innerChnages = location?.state?.innerChnages;
  let createCatalog = location?.state?.isCatalog;

  const { clientId } = useParams();
  const savedClientName = sessionStorage.getItem("clientName");
  const clientNameRef = useRef(state?.clientName || savedClientName);
  const isCreateCatalog = location?.state?.isCatalog;

  const navigate = useNavigate();
  const { createBtn, setCreateBtn } = useClientContext();
  const { cartData, setCartData, searchPlaceHolder} = useGlobalContext();
  const { search } = useContext(SortContext);

  const dispatch = useDispatch();
  const countCart = useSelector(
    (state) => state.cart.cartData.length
  ); 

  const permissions=usePermissions();

  const hasAccessToCreatePartialPurchaseCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Purchases"), "create_partial_purchase_catalog"); 

  // const hiddenSearchPaths = ["/client-flow/1/clients-purchases", "/client-flow/1/clients-catalog", "/client-flow/1/quotes-orders", "/client-flow/1/wip"];

  // const hideSearch = hiddenSearchPaths.some((path) => location.pathname.startsWith(path));

  const handleExit = () => {
    navigate("/Clients");
  };

  const handleCancel = () => {
    navigate(-1);
    setCreateBtn(true);
    dispatch(clearCart());
    // setCartData([]);
  };

  // const updateCartCount = () => {
  //   setCountCart(cartData.length);
  // };
  // useEffect(() => {
  //   updateCartCount();

  //   const handleCartUpdated = () => {
  //     updateCartCount();
  //   };

  //   window.addEventListener("cartUpdated", handleCartUpdated);

  //   return () => {
  //     window.removeEventListener("cartUpdated", handleCartUpdated);
  //   };
  // }, [cartData]);

  const handleShowCart = () => {
    if (innerChnages || createCatalog) {
      state = { ...state, openCart: true, clientDetails: false, innerChnages: true, newName: "New Catalog", backPath: "/Clients" };
      navigate("/Cart", { state });
    }
  };

  return (
    <>
      <AppBar
        // position="fixed"
        elevation={0}
        sx={{ backgroundColor: "#000", padding: "5px 27px 2px 5px" }}
      >
        <Toolbar sx={{ display: "flex !important", justifyContent: "space-between !important", padding: "0px !important", gap: "15px" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 400,
              color: "#FFFFFF",
              marginLeft: isCreateCatalog ? "25px" : "108px",
              lineHeight: "36px",
              whiteSpace: "nowrap",
            }}
          >
            {clientNameRef?.current} <span style={{ color: "#A1A1A1" }}>{`(#${clientId})`}</span>
          </Typography>
          {/* Search & Action Section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "24px",
              width: "100%",
              marginLeft: "15px",
            }}
          >
            {/* Search Box */}
            {search && (
              <Search
                sx={{
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "10px",
                  paddingRight: "4px",
                  maxWidth: "500px",
                  marginRight: "20px",
                }}
              >
                <SearchIconPlaceHolder style={{ color: "gray", marginRight: "8px" }} />
                <StyledInputBase placeholder={searchPlaceHolder} />
                <IconButton
                  disableRipple
                  sx={{
                    height: "34px",
                    width: "69px",
                    borderRadius: "5px",
                    padding: "10px",
                    background: "#000",
                    color: "#fff",
                    fontWeight: 500,
                    fontSize: "12px",
                  }}
                >
                  Search
                </IconButton>
              </Search>
            )}

            {/* Create Button */}
            {createBtn && !innerChnages && hasAccessToCreatePartialPurchaseCatalog && (
              <StyledButton
                sx={{ marginRight: "1vw" }}
                bgcolor={"#50C878"}
                onClick={() => {
                  setCreateBtn(false);
                  let state = {
                    innerChnages: true,
                    isCatalog: true,
                  };
                  navigate(`${location.pathname}`, { state });
                }}
              >
                Create Catalog
              </StyledButton>
            )}

            {/* Quick Create */}
            {!isCreateCatalog && (
              <Tooltip title="Quick Create" marginTop="-5px">
                <IconButton size="large" edge="start" disableRipple sx={{ padding: "0px" }}>
                  <QuickCreate />
                </IconButton>
              </Tooltip>
            )}

            {/* Notification Icon */}
            {!isCreateCatalog && (
              <Tooltip title="Notifications" marginTop="-5px">
                <IconButton size="large" disableRipple sx={{ padding: "0px" }}>
                  <Badge badgeContent={0} color="success">
                    <NotificationIcon color="white" />
                  </Badge>
                </IconButton>
              </Tooltip>
            )}

            {/* Menu (9 dots) */}
            {!isCreateCatalog && (
              <Tooltip title="Menu" marginTop="-5px">
                <IconButton size="large" disableRipple sx={{ padding: "0px" }}>
                  <Nine_dots />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          {isCreateCatalog && (
            <Tooltip title="Cart" marginTop="-5px">
              <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple onClick={handleShowCart}>
                <Badge
                  badgeContent={countCart}
                  color="success"
                  sx={{
                    mr: !isCreateCatalog ? "auto" : "10px",
                  }}
                >
                  <CartIcon color={!countCart ? "white" : "#50C878"} />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
          <ExitButton onClick={isCreateCatalog ? handleCancel : handleExit}>
            {!isCreateCatalog && <ExitIcon />}
            {isCreateCatalog ? "Cancel" : "Exit"}
          </ExitButton>
        </Toolbar>
      </AppBar>

      {/* Divider Below Header */}
      <Box
        sx={{
          border: "1px solid #000",
          display: "flex",
          justifyContent: "center",
          padding: "0px",
          paddingBottom: "10px",
          position: "sticky",
          zIndex: 1000,
          top: "71px",
          backgroundColor: "black !important",
          marginRight: "25px",
          marginLeft: isCreateCatalog ? "25px" : "",
        }}
        maxWidth={"100%"}
      >
        <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%" }} />
      </Box>
    </>
  );
};

export default ClientsFlowHeader;
